import { render } from "./ForgotPassword.vue?vue&type=template&id=a7c8524c"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"
script.render = render

export default script